import { booleanAttribute } from "#ce/utils/props";

// `checked` is absent on purpose and is documented in the story: the element owns a live `checked`
// property, which a declared prop would shadow with an accessor onto the prop store. The `checked`
// attribute names the state a reset restores, the way it does on a native checkbox.
export const props = Object.freeze({
  /**
   * Text rendered next to the switch. Clicking the label toggles the checked state.
   *
   * @type {String}
   * @default undefined
   */
  label: {
    type: String,
    default: undefined,
  },
  /**
   * name attribute used for the element's form value — required to participate in a native form submit.
   *
   * @type {String}
   * @default undefined
   */
  name: {
    type: String,
    default: undefined,
  },
  /**
   * Text submitted under `name` while the switch is on. An off switch submits nothing, the way a
   * native checkbox behaves.
   *
   * @type {String}
   * @default "on"
   */
  value: {
    type: String,
    default: "on",
  },
  /**
   * Require the switch to be on before its form can be submitted. Presence-based, the way the
   * platform reads a boolean attribute: any value other than `false` constrains the field.
   *
   * @type {Boolean|String}
   * @default false
   */
  required: booleanAttribute(),
  /**
   * Message the browser shows when a required switch is submitted off. Names what this particular
   * switch is for; the generic wording comes from `frontend.forms`.
   *
   * @type {String}
   * @default undefined
   */
  requiredMessage: {
    type: String,
    default: undefined,
  },
  /**
   * Disable user interaction. Disabled switches keep their visual state but ignore clicks.
   *
   * @type {Boolean|String}
   * @default false
   */
  disabled: booleanAttribute(),
  /**
   * Secondary text rendered below the switch row — typically describes the effect of toggling.
   *
   * @type {String}
   * @default undefined
   */
  helpText: {
    type: String,
    default: undefined,
  },
  /**
   * Render the label before the switch instead of after.
   *
   * @type {Boolean|String}
   * @default false
   */
  labelPrepend: booleanAttribute(),
});
